import React from "react";
const CustomPageNevBtn = ({ setActivePage, activePage, pages }) => {
  return (
    <div className="reports-navbar">
      <div className="d-flex justify-content-center">
        <div className="reports-navbar-inner">
          <div className="reports-title">
            <span className="reports-title-line"></span>
            <span></span>
          </div>

          <div className="reports-buttons">
            {pages.map((pageName, index) => (
              <button
                key={index}
                type="button"
                onClick={() => setActivePage(pageName)}
                className={`report-nav-btn ${
                  activePage === pageName ? "report-nav-active" : ""
                }`}
              >
                <span className="report-nav-number">
                  {String(index + 1).padStart(2, "0")}
                </span>

                <span className="report-nav-text">{pageName}</span>

                <span className="report-nav-arrow">›</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
export default CustomPageNevBtn;
